import React, { useContext } from "react";
import "../css/login.css";
import { UserService } from "../Services/UserService";
import { Divider, Grid, Hidden, makeStyles } from "@material-ui/core";
import {  FormControl, Button, InputLabel, IconButton, InputAdornment, OutlinedInput } from "@material-ui/core";
import clsx from 'clsx';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useHistory } from "react-router-dom";
import { AppContext } from "../AppContextProvider";
import { useState } from "react";
import { messaging, requestToken, messaginIsSupported } from "../init-fcm";

const useStyles = makeStyles(theme =>({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: 300,
  },
}));

export default function Login(props){

  const classes = useStyles();
  const history = useHistory();
  const {setTitle, showSnackBar, setAuthenticating, setLinearLoading, updateUser, userHasAuthenticated, showProgressDialog, closeProgressDialog, showConfirmDialog, closeConfirmDialog} = useContext(AppContext);

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  React.useEffect(() => {
    setTitle('');
    const user = localStorage.getItem('caretaker.user') !== null ? JSON.stringify(localStorage.getItem('caretaker.user')) : null;
    const session = localStorage.getItem('caretaker.session');
    if(user !== null && session !== null) {
      history.push("/");
    } else {
      setAuthenticating(false);
    }
  }, [true])

  // const validateForm = () => {
  //   return email.length > 5 && password.length > 3;
  // }

  const handleChange = event => {
    if(event.target.name === 'password'){
      setPassword(event.target.value)
    } else if(event.target.name === 'email'){
      setEmail(event.target.value)
    }
  }

  const requestResetPassword = event => {
    showConfirmDialog(undefined, 'Reset Password', (email) => {
      showProgressDialog();
      UserService.requestResetPassword({email: email})
      .then(data => {
        closeProgressDialog();
        closeConfirmDialog();
        if(data.success){
          showConfirmDialog(data.message, undefined);
        } else {
          showConfirmDialog(data.message, undefined);
        }
      })
      .catch(error => {
        closeProgressDialog();
        closeConfirmDialog();
        showConfirmDialog('something went wrong. Please try again later', undefined);
      })
    }, 'Cancel', 'Reset', true, 'Please enter Account Email address');
  }

  const handleSubmit = event => {
    event.preventDefault();
      try {
        setLinearLoading(true);
        UserService.authenticate({email, password})
        .then((data) => {
            if (data.id && data.status === "1") {
                updateUser(data);
                // console.log("Logged in");
                // console.log(data);
                localStorage.setItem('caretaker.user', JSON.stringify(data));
                localStorage.setItem('caretaker.session', data['sysbrew-x-token']);
                userHasAuthenticated(true);
                
                if(messaginIsSupported){
                  messaging.requestPermission()
                  .then( () => {
                      console.log("Have Permission");
                      requestToken(data);
                  })
                  .catch((err) => {
                    console.log("Unable to get permission to notify.", err);
                  });
                }
                history.push("/");
            } else if(data.status === 0){
              showSnackBar("Your account has been deactivated. Contact Admin" , 'error');
            } else if(data.message){
              showSnackBar(data.message , 'error');
            }
            setLinearLoading(false);
        })
        .catch((error) => {
          showSnackBar("Failed to Login. invalid credentials" , 'error');
          setLinearLoading(false);
        });
      } catch (e) {
        alert(e.message);
        setLinearLoading(false);
      }
  }

  const handleClickShowPassword = () => {
    setShowPassword(prevState => (!prevState.showPassword));
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <div className="Login" style={{height: '100vh'}}>
      <Grid container direction="row" justify="center" alignItems="center" style={{height: '50vh'}}>
        <Grid item xs={12} lg={6}>
          <img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="Logo" height={200}/>
        </Grid>
        <Hidden mdDown>
          <Grid item xs={1} lg={1} style={{height: '50vh'}}>
            <Divider orientation="vertical" variant="middle"/>
          </Grid>
        </Hidden>
        <Grid item xs={12} lg={5}>
          <form onSubmit={handleSubmit}>
            <FormControl className={clsx(classes.margin, classes.textField)}  variant="outlined">
              <InputLabel htmlFor="standard-adornment-email">Email</InputLabel>
              <OutlinedInput
                id="standard-adornment-email"
                type={'email'}
                value={email}
                name="email"
                onChange={handleChange}
                labelWidth={40}
              />
            </FormControl>
            <FormControl className={clsx(classes.margin, classes.textField)}  variant="outlined">
              <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
              <OutlinedInput
                id="standard-adornment-password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                name="password"
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                labelWidth={70}
              />
            </FormControl>
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <Button variant="contained" color="primary" onClick={handleSubmit} size="large">
                Login
              </Button>
            </FormControl>
          </form>
          <Button variant="text" color="primary" onClick={requestResetPassword}>Forgot Password?</Button>
        </Grid>
      </Grid>
    </div>
  );
}